exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-602f49e0] {\n  text-align: center;\n}\n.venmo-container[data-v-602f49e0] {\n  text-align: center;\n  margin: 1rem 0;\n}", ""]);

// exports
